import Loadable from '../../components/loadable';

const ContactMandates = Loadable({
  loader: () => import('../../pages/contacts/mandates'),
});

angular.module('gym').value('ContactMandates', ContactMandates);
